// Hidden samples for ResizeObserver tier selection (list-row project pills).
import TagChip from '@/components/ui/TagChip';
import { abbreviateProjectDisplayName } from '@/features/tasks/utils/ui/projectPillAbbreviation';

/**
 * @param {{ displayNames: string[], dense: boolean }} props
 */
export function TaskRowProjectPillTierMeasurer({ displayNames, dense }) {
  if (displayNames.length === 0) return null;

  const abbrevLabels = displayNames.map((name) =>
    abbreviateProjectDisplayName(name),
  );

  const rowSx = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    flexWrap: 'nowrap',
  };

  return (
    <>
      <div data-project-pill-measure="full" style={rowSx}>
        {displayNames.map((name) => (
          <TagChip
            key={`full-${name}`}
            tag={name}
            label={name}
            dense={dense}
            listRowProjectPill
            projectDisplayTier="full"
            measureOnly
          />
        ))}
      </div>
      <div data-project-pill-measure="abbrev" style={rowSx}>
        {abbrevLabels.map((label, i) => (
          <TagChip
            key={`abbrev-${displayNames[i]}`}
            tag={displayNames[i]}
            label={label}
            dense={dense}
            listRowProjectPill
            projectDisplayTier="abbrev"
            measureOnly
          />
        ))}
      </div>
      <div data-project-pill-measure="dot" style={rowSx}>
        {displayNames.map((name) => (
          <TagChip
            key={`dot-${name}`}
            tag={name}
            label={name}
            dense={dense}
            listRowProjectPill
            projectDisplayTier="dot"
            measureOnly
          />
        ))}
      </div>
    </>
  );
}
